var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8541713_crown_icon 5",
    clipPath: "url(#clip0_12501_5569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4385 10.5H2.63846C2.43115 10.5 2.26154 10.6687 2.26154 10.875V11.625C2.26154 11.8313 2.43115 12 2.63846 12H12.4385C12.6458 12 12.8154 11.8313 12.8154 11.625V10.875C12.8154 10.6687 12.6458 10.5 12.4385 10.5ZM13.9462 3C13.3219 3 12.8154 3.50391 12.8154 4.125C12.8154 4.29141 12.8531 4.44609 12.919 4.58906L11.2135 5.60625C10.8507 5.82188 10.3819 5.7 10.1722 5.33438L8.25226 1.99219C8.50433 1.78594 8.66923 1.47656 8.66923 1.125C8.66923 0.503906 8.16274 0 7.53846 0C6.91418 0 6.40769 0.503906 6.40769 1.125C6.40769 1.47656 6.5726 1.78594 6.82466 1.99219L4.90471 5.33438C4.69505 5.7 4.22389 5.82188 3.86346 5.60625L2.16024 4.58906C2.22385 4.44844 2.26389 4.29141 2.26389 4.125C2.26389 3.50391 1.7574 3 1.13312 3C0.508846 3 0 3.50391 0 4.125C0 4.74609 0.50649 5.25 1.13077 5.25C1.19202 5.25 1.25327 5.24062 1.31216 5.23125L3.01538 9.75H12.0615L13.7648 5.23125C13.8237 5.24062 13.8849 5.25 13.9462 5.25C14.5704 5.25 15.0769 4.74609 15.0769 4.125C15.0769 3.50391 14.5704 3 13.9462 3Z",
    fill: "#FDD446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12501_5569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0769,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5765a7645cd447260b00c370ef8f1bc0.svg";
export { ForwardRef as ReactComponent };